import initCitrixWebRTC from '../citrix/CitrixWebRTC';
import Janus from '../external/janus.es'

let vdiCitrix: any = null
let originalGetUserMedia: any
let originalEnumerateDevices: any
let originalPeerConnection: any

// this is purely only used for debugging by simulating citrix VDI connection events.
(window as any).handleCitrixEventCallback = handleCitrixEventCallback;

export {
    registerWebRtcGlobals,
}

function registerWebRtcGlobals() {
    console.log('Registering WebRTC Globals')
    initCitrixWebRTC()
    vdiCitrix = window.CitrixWebRTC
    originalGetUserMedia = navigator.mediaDevices.getUserMedia
    originalEnumerateDevices = navigator.mediaDevices.enumerateDevices
    originalPeerConnection = global.RTCPeerConnection

    // Should not happen. React Native has a global navigator object.
    if (typeof navigator !== 'object') {
        throw new Error('navigator is not an object');
    }

    console.log('VDICitrix', vdiCitrix)
    vdiCitrix.setVMEventCallback(handleCitrixEventCallback)
}

function restoreOriginalWebRtc() {
    window.citrixVdaSupport = false
    Janus.setUnifiedPlan(true)
    navigator.mediaDevices.getUserMedia = originalGetUserMedia
    navigator.mediaDevices.enumerateDevices = originalEnumerateDevices
    global.RTCPeerConnection = originalPeerConnection
}

function replaceWebRtcWithCitrix() {
    function getUserMedia(constraints: MediaStreamConstraints): Promise<MediaStream> {
        return new Promise<MediaStream>((resolve, reject) => {
            return vdiCitrix.getUserMedia(constraints, resolve, reject)
        })
    }

    class AsyncPeerConnection extends vdiCitrix.CitrixPeerConnection {
        public createOffer(options?: RTCOfferOptions) {
            return new Promise<RTCSessionDescriptionInit>((resolve, reject) => {
                super.createOffer(resolve, reject, options)
            })
        }

        public createAnswer(options?: RTCOfferOptions) {
            return new Promise<RTCSessionDescriptionInit>((resolve, reject) => {
                super.createAnswer(resolve, reject, options)
            })
        }

        public setLocalDescription(description: RTCSessionDescriptionInit) {
            return new Promise<void>((resolve, reject) => {
                super.setLocalDescription(description, resolve, reject)
            })
        }

        public setRemoteDescription(description: RTCSessionDescriptionInit) {
            return new Promise<void>((resolve, reject) => {
                super.setRemoteDescription(description, resolve, reject)
            })
        }
    }

    window.citrixVdaSupport = true  // we can assume true because register should only be called when it was true.
    Janus.setUnifiedPlan(false)
    if (!navigator.mediaDevices) {
        // @ts-ignore
        navigator.mediaDevices = {};
    }
    navigator.mediaDevices.getUserMedia = getUserMedia
    navigator.mediaDevices.enumerateDevices = vdiCitrix.enumerateDevices.bind(vdiCitrix);
    global.RTCPeerConnection = AsyncPeerConnection as any
    // global.RTCIceCandidate = RTCIceCandidate;
    // global.RTCSessionDescription = vdiCitrix.RTCSessionDescription;
    // global.MediaStream = MediaStream;
    // global.MediaStreamTrack = MediaStreamTrack;     
}

function handleCitrixEventCallback(event: any) {
    console.info('VM Event Callback', event)
    if (event.event === 'vdiClientDisconnected') {
        console.warn('Citrix VDI client disconnected, falling back to standard WebRTC implementation')
        restoreOriginalWebRtc()
    } else if (event.event === 'vdiClientConnected') {
        console.info('Citrix VDI Client connected, switching to Citrix WebRTC implementation')
        replaceWebRtcWithCitrix()
    }
}